import dayjs from 'dayjs';
import exportFromJSON from 'export-from-json';



export const VirtualAccountTrsaction = (data) => {
    return data?.virtualAccountCollections.map((item) => ({
        transactionId:  item.transaction.tnxRef,
        accountNumber: item.virtualAccountNumber,
        amountReceived: `${item.transaction.currency} ${item.transaction.amount}`,
        amountSettled: `${item.transaction.currency} ${item.transaction.settledAmount}`,        
        date:  dayjs(item.transaction.createdAt).format("DD.MM.YYYY HH:mm"),
    
    }))
}


export const exportVirtualAccountData = async (transaction, fileType) => {
    const data = await VirtualAccountTrsaction(transaction);
  
    const exportType =
      fileType === "csv"
        ? exportFromJSON.types.csv
        : fileType === "xls"
        ? exportFromJSON.types.xls
        : null;
  
    if (!exportType) {
      return ("Invalid export file type");
    }
  
    exportFromJSON({
      data,
      fileName: "Virtual Account Trsancation",
      exportType,
    });
  };
